<template>
    <div class="bottom">
        <img class="text" src="../images/share_bottom_text@3x.png" alt="网易蜗牛读书">
        <div class="download" @click="downloadClickHandler">下载网易蜗牛读书</div>
    </div>
</template>
<script>
export default {
    name: 'bottom',
    props: {
        logHandler: Function
    },
    methods: {
        downloadClickHandler(){
            if(this.logHandler){
                this.logHandler();
                setTimeout(() => {
                    location.href = '/download'
                }, 300);
            }else{
                location.href = '/download'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .bottom{
        height: 6.21rem;
        position: relative;
        overflow: hidden;
        background: url(../images/share_wap_bottom_bg@3x.png) center bottom no-repeat;
        background-size: 100% auto;
        .text{
            display: block;
            margin: .97rem auto .58rem;
            width: 3.58rem;
        }
        .download{
            width: 4.6rem;
            height: 1rem;
            line-height: 1rem;
            border-radius: 1rem;
            margin: 0 auto 1.87rem;
            background: #ce5959;
            box-shadow: 0 .12rem .54rem 0 rgba(145,10,10,0.16);
            color: #fff;
            text-align: center;
            font-size: .32rem;
            &:active{
                background: rgba(0, 0, 0, 0.05);
            }
        }
    }
</style>

